import styles from './PriceList.module.scss';
import { pricingData } from '../../../data/pricing';

const PriceList = () => {
  return (
    <div className={styles.price}>
      <div>
        <h1 className={styles.title}>Cennik</h1>
        <p className={styles.info}>
          Centrum Rozwoju i Terapii MOTUS s.c. Anna Paluch Jaroław Słoma
          <b> nie pobiera opłat za wydanie dokumentacji medycznej</b>. Cennik
          obowiązuje od 01.12.2025 roku.
        </p>
      </div>
      {/* loops  */}
      {pricingData.map((price) => (
        <div key={price.category}>
          <h2>{price.category}</h2>
          <div className={styles.allBox}>
            {price.items.map((item, index) => (
              <div className={styles.box} key={index}>
                <h3>{item.title}</h3>
                <p className={styles.description}>{item.description}</p>
                <p className={styles.cost}> {item.price}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PriceList;
